import React from 'react';
import { Link } from 'react-router-dom';
import { Users, ArrowRight, Sparkles, CalendarClock, HandCoins } from 'lucide-react';

/**
 * Full-width dark green section promoting the group booking flow (/grup-rezervasyonu).
 * Placed on the home page (similar rhythm to BlogCta).
 */
const GroupInquiryPromo = () => {
  return (
    <section
      className="relative py-16 md:py-24 bg-[#2d3a1a] text-white overflow-hidden"
      data-testid="group-inquiry-promo"
    >
      {/* Subtle radial highlight */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            'radial-gradient(circle at 20% 20%, #4a5f2c 0, transparent 55%), radial-gradient(circle at 85% 80%, #3D4A26 0, transparent 60%)',
        }}
      />
      {/* Grain texture */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
        }}
      />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-12 items-center">
          {/* Copy column */}
          <div className="md:col-span-3">
            <p className="flex items-center gap-2 text-[11px] md:text-xs uppercase tracking-[0.25em] font-semibold text-[#C8D843] mb-3">
              <Sparkles size={13} /> 4+ Kişi
            </p>
            <h2
              className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-4"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              Grubunuz mu var? <span className="text-[#C8D843]">Size özel</span> çıkış planlayalım.
            </h2>
            <p className="text-white/80 text-base md:text-lg leading-relaxed max-w-xl mb-8">
              Aile, arkadaş çevresi ya da şirket ekibiyle mi geliyorsunuz? Kendi tarihinizde, gruba özel fiyatla,
              kokartlı rehber eşliğinde bir Likya Yolu veya Karya Yolu turu kurgulayalım. Programı sizin
              hızınıza ve tercihlerinize göre birlikte tasarlıyoruz.
            </p>

            <div className="flex flex-wrap gap-3 items-center">
              <Link
                to="/grup-rezervasyonu"
                data-testid="group-inquiry-promo-cta"
                className="inline-flex items-center gap-2 bg-[#C8D843] text-[#1B1B1B] font-bold px-6 md:px-7 py-3.5 rounded-full text-sm hover:bg-[#b8c83a] transition-all hover:gap-3"
              >
                Teklif İste <ArrowRight size={16} />
              </Link>
              <a
                href="https://api.whatsapp.com/send?phone=908504959524&text=Merhaba%2C%20grup%20rezervasyonu%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
                target="_blank"
                rel="noopener noreferrer"
                data-testid="group-inquiry-promo-whatsapp"
                className="inline-flex items-center gap-2 text-white/85 font-semibold text-sm underline underline-offset-4 decoration-white/30 hover:decoration-white"
              >
                WhatsApp&apos;tan yaz
              </a>
            </div>
          </div>

          {/* Perks column */}
          <div className="md:col-span-2">
            <ul className="space-y-4">
              {[
                {
                  icon: HandCoins,
                  title: 'Özel Grup Fiyatı',
                  desc: 'Grup boyutuna göre kişi başı indirimli teklif',
                },
                {
                  icon: CalendarClock,
                  title: 'Kendi Tarihiniz',
                  desc: 'Gruba özel çıkış — takvimden bağımsız',
                },
                {
                  icon: Users,
                  title: 'Kişiye Özel Program',
                  desc: 'Yürüyüş temposu, diyet, konaklama sizinle netleşir',
                },
              ].map((p) => {
                const Icon = p.icon;
                return (
                  <li key={p.title} className="flex items-start gap-3 bg-white/5 backdrop-blur-sm rounded-xl px-4 py-3.5 border border-white/10">
                    <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-[#C8D843]/15 flex items-center justify-center">
                      <Icon size={16} className="text-[#C8D843]" strokeWidth={2.2} />
                    </div>
                    <div>
                      <p className="font-bold text-sm text-white">{p.title}</p>
                      <p className="text-white/70 text-xs md:text-[13px] leading-relaxed mt-0.5">{p.desc}</p>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GroupInquiryPromo;
